import { TourProvider } from '@reactour/tour'
import history from 'history.js'
import moment from 'moment'
import { SnackbarProvider } from 'notistack'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import '../styles/_app.scss'
import I18nConnectedProvider from '../translation/I18nConnectedProvider'
import InactivityDetector from './InactivityDetector'
import routes from './RootRoutes'
import AppContext from './appContext'
import Auth from './auth/Auth'
import AuthGuard from './auth/AuthGuard'
import AppLayout from './layout/AppLayout'
import { Store } from './redux/Store'
import { CHTCtheme } from './theme/CHTCtheme'
import { GlobalValues } from './utils/GlobalValues'
import { CustomSnackbar } from './views/common-components/CustomSnackbars'

// lock site for maintenance
const maintenance = false
moment.updateLocale('iu', {
  months: [
    'ᔭᓄᐊᕆ',
    'ᕕᕗᐊᕆ',
    'ᒫᔾᔨ',
    'ᐊᐃᕆᓕ',
    'ᒪᐃ',
    'ᔫᓂ',
    'ᔪᓚᐃ',
    'ᐊᐅᒍᓯ',
    'ᓯᑎᐱᕆ',
    'ᐅᑐᐱᕆ',
    'ᓄᕕᐱᕆ',
    'ᑎᓯᐱᕆ'
  ],
  monthsShort: [
    'ᔭᓄᐊᕆ',
    'ᕕᕗᐊᕆ',
    'ᒫᔾᔨ',
    'ᐊᐃᕆᓕ',
    'ᒪᐃ',
    'ᔫᓂ',
    'ᔪᓚᐃ',
    'ᐊᐅᒍᓯ',
    'ᓯᑎᐱᕆ',
    'ᐅᑐᐱᕆ',
    'ᓄᕕᐱᕆ',
    'ᑎᓯᐱᕆ'
  ],
  weekdays: ['ᓈᑦᑏᖑᔭᖅ', 'ᓇᒡᒐᔾᔭᐅ', 'ᐊᐃᑉᐹ', 'ᐱᖓᔪᐊ', 'ᕿᑎᖅᑰ', 'ᐅᓪᓗᑐᐃᓐᓇᖅ', 'ᓯᕙᑖᕐᕕᒃ'],
  weekdaysShort: [
    'ᓈᑦᑏᖑᔭᖅ',
    'ᓇᒡᒐᔾᔭᐅ',
    'ᐊᐃᑉᐹ',
    'ᐱᖓᔪᐊ',
    'ᕿᑎᖅᑰ',
    'ᐅᓪᓗᑐᐃᓐᓇᖅ',
    'ᓯᕙᑖᕐᕕᒃ'
  ]
})
moment.updateLocale('fr', {
  months: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ],
  monthsShort: [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre'
  ],
  weekdaysShort: [
    'Dimanche',
    'Lundi',
    'Mardi',
    'Mercredi',
    'Jeudi',
    'Vendredi',
    'Samedi'
  ]
})
moment.updateLocale('en', { week: { dow: 1 } })
moment.updateLocale('en', {
  monthsShort: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  weekdaysShort: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
  ]
})

const App = () => {
  return (
    <AppContext.Provider value={{ routes }}>
      <Provider store={Store}>
        <I18nConnectedProvider>
          <SnackbarProvider
            Components={{
              success: CustomSnackbar,
              error: CustomSnackbar,
              warning: CustomSnackbar,
              info: CustomSnackbar
            }}
            maxSnack={3}
            autoHideDuration={2000}
          >
            <CHTCtheme>
              <TourProvider
                steps={[]}
                onClickClose={({ setIsOpen, setCurrentStep }) => {
                  setIsOpen(false)
                  setCurrentStep(0)
                }}
                styles={{
                  popover: base => ({
                    ...base,
                    '--reactour-accent': '#5cb7b7'
                  })
                }}
              >
                <Router history={history}>
                  <Auth maintenance={maintenance}>
                    <GlobalValues>
                      <AuthGuard>
                        <AppLayout />
                        <InactivityDetector />
                        {/* <MissingUserInformationPopUp /> */}
                      </AuthGuard>
                    </GlobalValues>
                  </Auth>
                </Router>
              </TourProvider>
            </CHTCtheme>
          </SnackbarProvider>
        </I18nConnectedProvider>
      </Provider>
    </AppContext.Provider>
  )
}

export default App
